var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarPlotOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7002 12H4.7002C4.14791 12 3.7002 12.4477 3.7002 13V18C3.7002 18.5523 4.14791 19 4.7002 19H6.7002C7.25248 19 7.7002 18.5523 7.7002 18V13C7.7002 12.4477 7.25248 12 6.7002 12Z",
    fill: "#272D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7002 12.5H4.7002C4.42405 12.5 4.2002 12.7239 4.2002 13V18C4.2002 18.2761 4.42405 18.5 4.7002 18.5H6.7002C6.97634 18.5 7.2002 18.2761 7.2002 18V13C7.2002 12.7239 6.97634 12.5 6.7002 12.5Z",
    stroke: "#272D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7002 2.5H9.7002C9.14791 2.5 8.7002 2.94772 8.7002 3.5V18C8.7002 18.5523 9.14791 19 9.7002 19H11.7002C12.2525 19 12.7002 18.5523 12.7002 18V3.5C12.7002 2.94772 12.2525 2.5 11.7002 2.5Z",
    fill: "#272D55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7002 3H9.7002C9.42405 3 9.2002 3.22386 9.2002 3.5V18C9.2002 18.2761 9.42405 18.5 9.7002 18.5H11.7002C11.9763 18.5 12.2002 18.2761 12.2002 18V3.5C12.2002 3.22386 11.9763 3 11.7002 3Z",
    stroke: "#272D55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7002 8H14.7002C14.1479 8 13.7002 8.44772 13.7002 9V18C13.7002 18.5523 14.1479 19 14.7002 19H16.7002C17.2525 19 17.7002 18.5523 17.7002 18V9C17.7002 8.44772 17.2525 8 16.7002 8Z",
    fill: "#272D55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7002 8.5H14.7002C14.4241 8.5 14.2002 8.72386 14.2002 9V18C14.2002 18.2761 14.4241 18.5 14.7002 18.5H16.7002C16.9763 18.5 17.2002 18.2761 17.2002 18V9C17.2002 8.72386 16.9763 8.5 16.7002 8.5Z",
    stroke: "#272D55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1V19",
    stroke: "#272D55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19H1",
    stroke: "#272D55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarPlotOperationIcon);
export default __webpack_public_path__ + "static/media/BarPlotOperationIcon.b3bdc57227fc6a0f3dc64544bfe2932a.svg";
export { ForwardRef as ReactComponent };